module.exports = __webpack_public_path__ + "img/dian.35d0892a.png";